<script>
export default {
  name: "ManageProduct",
  data: () => {
    return {
      products: '',
      objs: [],
      search: '',
      product: {
        title: '',
        expenseObj: '',
        expenseObjTitle: '',
      },
      editingProduct: '',
      editingProductObjTitle: '',
      selectedObjName: '',
      selectedObjId: '',
      mapObjs: {},
    }
  },
  computed: {
    sidebarData() {
      return this.$store.getters['sidebarData'];
    },
    filteredProducts() {
      if (!this.search) {
        return this.products;
      }
      return this.products.filter(products => products.title.toLowerCase().includes(this.search.toLowerCase()));
    }
  },
  methods: {
    async getProductsData() {
      try {
        let res = await this.$api.get("/auth/products");
        if (res.status.toString() === "200") {
          this.products = res.data
        }
      } catch (error) {
        console.log("can't get products data")
      }
    },
    async getObjData() {
      try {
        let res = await this.$api.get("/auth/expense-objects");
        if (res.status.toString() === "200") {
          this.objs = res.data
        }
      } catch (error) {
        console.log("can't get obj data")
      }
    },
    async regProducts() {
      if (this.product.title.length < 3 || this.product.expenseObj === 0) {
        this.$swal.fire({
          icon: 'error',
          title: 'Verifique los datos nuevamente',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }
      try {
        let data = {
          title: this.product.title, expenseObj: this.product.expenseObj,
        }
        let result = await this.$api.post("/auth/products", data, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        });

        if (result.status.toString() === "201") {
          this.$swal.fire({
            icon: 'success',
            title: 'Se han guardado los cambios',
            customClass: {
              popup: 'mySwal'
            }
          })
          await this.getProductsData()
          this.product = {
            title: '',
            expenseObj: '',
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'No se han podido registrar los  cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          });
        }
      } catch (error) {
        console.log("reg error", error)
        this.$swal.fire({
          icon: 'error',
          title: 'No se han podido registrar los cambios',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async regProductChanges() {
      if (this.editingProduct.title.length < 3 || this.editingProduct.expenseObj === 0) {
        this.$swal.fire({
          icon: 'error',
          title: 'Verifique los datos nuevamente',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }
      try {
        let data = {
          title: this.editingProduct.title, expenseObj: this.editingProduct.expenseObject,
        }
        let result = await this.$api.put(`/auth/products/${this.editingProduct.id}`, data, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        });

        if (result.status.toString() === "201") {
          this.$swal.fire({
            icon: 'success',
            title: 'Se han guardado los cambios',
            customClass: {
              popup: 'mySwal'
            }
          })
          await this.getProductsData()
          this.editingProduct = ''
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'No se han podido registrar los cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          });
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: 'No se han podido registrar los cambios',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        })
      }

    },
    getIDObj() {
      let selectedItem = this.objs.find(obj => (obj.title.trim() + " ("+obj.code.trim()+")") === this.product.expenseObjTitle);

      if (selectedItem !== undefined) {
        this.product.expenseObj = selectedItem.id
      } else {
        this.product.expenseObj = 0
      }
    },
    getIDObjEdit() {
      let selectedItem = this.objs.find(obj => (obj.title.trim() + " ("+obj.code.trim()+")") === this.editingProductObjTitle);
      if (selectedItem !== undefined) {
        this.editingProduct.expenseObject = selectedItem.id
      } else {
        this.editingProduct.expenseObject = 0
      }
    },
    editProd(prod) {
      this.editingProduct = prod;
      this.getProductsData()
      this.editingProductObjTitle = this.getExpenseObjectById(prod.expenseObject).title.trim() + " ("+this.getExpenseObjectById(prod.expenseObject).code.trim() + ")"
    },
    cancelEdit() {
      this.editingProduct = ''
    },
    getExpenseObjectById(id) {
      return this.mapObjs[id] || {};
    },
    inputLimiterSearch() {
      this.search = this.search.replace(/[^a-z0-9 ()/%ñáéíóúü,.~\-"]/gi, '').trimStart();
    },
    inputLimiterTitle() {
      this.product.title = this.product.title.replace(/[^a-z0-9 ()/%ñáéíóúü,.~\-"]/gi, '').trimStart();
    },
    inputLimiterTitleEdit() {
      this.editingProduct.title = this.editingProduct.title.replace(/[^a-z0-9 ()/%ñáéíóúü,.~\-"]/gi, '').trimStart();
    },

  },

  created() {
    this.getProductsData()
    this.getObjData().then(() => {
      this.mapObjs = this.objs.reduce((map, obj) => ({...map, [obj.id]: obj}), {});
    });

  }
}

</script>

<template>
  <h1>Productos</h1>

  <div class="grid-container-left">

    <div>

      <form class="Form">
        <input type="text" v-model="search" v-on:input="inputLimiterSearch"
               placeholder="Buscar producto ...">
      </form>

      <div class="container mt-4 table-container" v-if="filteredProducts.length > 0">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>#</th>
            <th>Titulo</th>
            <th>Objeto de gasto</th>
            <th v-if="sidebarData.includes('ad-prov-prod-edit')">Opciones</th>
          </tr>

          </thead>
          <tbody>

          <tr v-for="(prod, index) in filteredProducts" :key="prod.id">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ prod.title }}</td>
            <td>{{ getExpenseObjectById(prod.expenseObject).title }}
              -
              {{ getExpenseObjectById(prod.expenseObject).code }}
            </td>
            <td class="td_align_center" v-if="sidebarData.includes('ad-prov-prod-edit')">
              <button class="tableBtn" @click="editProd(prod)" role="link">Editar</button>
            </td>
          </tr>

          </tbody>
        </table>
      </div>

      <div v-else>
        <p class="bordered-p">No hay productos disponibles.</p>
      </div>

    </div>

    <div v-if="sidebarData.includes('ad-prov-prod-reg') || editingProduct">
      <div v-if="!editingProduct">
        <h2>Registrar producto</h2>
        <form class="Form">
          <label>Titulo</label>
          <input type="text" v-model="product.title" v-on:input="inputLimiterTitle"
                 placeholder="Titulo del producto">
          <label>Objeto del gasto</label>
          <input list="objs" v-model="product.expenseObjTitle" @input="getIDObj" placeholder="Seleccione una opción">
          <datalist id="objs">
            <option v-for="obj in objs" :key="obj.id" :value="`${obj.title} (${obj.code})`" ></option>
          </datalist>
          <button type="submit" @click.prevent="regProducts">Registrar</button>
        </form>
      </div>

      <div v-if="editingProduct">
        <h2>Editar producto</h2>
        <form class="Form">
          <label>Titulo</label>
          <input type="text" v-model="editingProduct.title" v-on:input="inputLimiterTitleEdit"
                 placeholder="Titulo del objeto de gasto">
          <label>Objedo del gasto</label>
          <input list="objs" v-model="editingProductObjTitle" @input="getIDObjEdit" placeholder="Seleccione una opción" >
          <datalist id="objs">
            <option v-for="obj in objs" :key="obj.id" :value="`${obj.title} (${obj.code})`"></option>
          </datalist>
          <button type="submit" @click.prevent="regProductChanges">Guardar Cambios</button>
          <button type="submit" @click.prevent="cancelEdit">Cancelar</button>
        </form>
      </div>

      <div>
      </div>
    </div>

  </div>

</template>

<style >

</style>